import { Colors } from '@oy/uicore';
import { Spacer, Text } from '@oy/uidesktop';
import { useTranslate } from 'src/hooks';
import styles from './Sidebar.module.css';

type SectionTitleProps = {
  isProdEnv: boolean;
  title: string;
};

export const SectionTitle = ({ isProdEnv, title }: SectionTitleProps) => {
  const { getTranslation } = useTranslate();

  return (
    <Spacer top={Spacer.Size.XL} bottom={Spacer.Size.XS}>
      <Spacer top={Spacer.Size.S} />
      <Text
        textStyle={Text.Style.BodySmSemibold}
        color={(isProdEnv && 'var(--token-color-brand50)') || Colors.BLACK60}
        // TODO: The next improvement should use COLORS.BRAND100, etc.
        className={styles.sectionTitle}
      >
        {getTranslation(title)}
      </Text>
    </Spacer>
  );
};
